import { ILog } from './../../types';
import { IPhxStateService } from 'utility-ng-configuration';
import { IMemberDatasource, MemberDatasource } from '../../../global/datasources/member_datasource';

export class LicenseAgreementModalController {
  private open: boolean = true;
  public models: {
    data: IMemberDatasource;
  };

  constructor(public $state: IPhxStateService, private log: ILog, ngMemberDatasource: MemberDatasource) {
    this._initialize();
    this.models = {
      data: ngMemberDatasource.read()
    };
  }

  private _initialize(): void {}

  openedChanged(event: any) {
    if (!event.detail.value) {
      this.$state.includes('landing') ? this.$state.go('landing') : this.$state.__goToPrevious__();
    }
  }

  closeModal() {
    this.open = false;
  }
}

angular.module('capability-ng-global').controller('ngLicenseAgreementModalController', LicenseAgreementModalController);



// WEBPACK FOOTER //
// ./app/lib/global/modals/terms_of_use/terms_of_use.ts